import { TabContext } from '@mui/lab';
import { Box, Divider, Tooltip } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import InfoIcon from '../../assets/images/info-icon.svg';
import { TitleBox } from '../../components/UI/Box';
import { GridMain } from '../../components/UI/Grid';
import { IconAdminPanelSettingsMS } from '../../constants/icons';
import { Constants } from '../../constants/oversight';
import { StyledTabList, TabStyled } from '../Hive/styles';
import { StyledTabPanel } from '../UserManagement/styles';
import { Title } from './styles';
import { AdministrativeUsers } from './Tabs/AdministrativeUsers';
import { OversightClients } from './Tabs/Clients';

export function Oversight(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = location.pathname.split('/').pop() ?? 'clients';

  return (
    <GridMain>
      <TitleBox>
        <Title>
          {IconAdminPanelSettingsMS}
          {Constants.oversight}
          <Tooltip
            describeChild
            title={Constants.oversight_title_tooltip}
            slotProps={{
              tooltip: {
                sx: {
                  whiteSpace: 'nowrap',
                  maxWidth: 'none',
                },
              },
            }}
          >
            <img src={InfoIcon} alt="Ícone de informação" />
          </Tooltip>
        </Title>
      </TitleBox>
      <Box>
        <TabContext value={currentTab}>
          <StyledTabList
            onChange={(_, newValue) => navigate(`/oversight/${newValue}`)}
          >
            <TabStyled label="Clientes" value="clients" />
            <TabStyled
              label="Usuários Administrativos"
              value="administrative-users"
            />
          </StyledTabList>
          <Divider />
          <StyledTabPanel value="clients">
            <OversightClients />
          </StyledTabPanel>
          <StyledTabPanel value="administrative-users">
            <AdministrativeUsers />
          </StyledTabPanel>
        </TabContext>
      </Box>
    </GridMain>
  );
}
